var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHibernate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1540_239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1540_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.799 3L32.6005 27.6512L17.7918 52.3371L3 27.6512L17.799 3Z",
    fill: "#59666C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4068 3.00098H17.8075L32.6089 27.6522H62.2166L47.4068 3.00098Z",
    fill: "#BCAE79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2012 76.9997L47.3998 52.3485L62.2084 27.6626L77.0002 52.3485L62.2012 76.9997Z",
    fill: "#59666C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5932 76.9979H62.196L47.4066 52.3467H17.7833L32.5932 76.9979Z",
    fill: "#BCAE79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibernate);
export default __webpack_public_path__ + "static/media/Hibernate.9ccede8a85f0eb3b14edd349a9279da9.svg";
export { ForwardRef as ReactComponent };